// src/components/screens/ClubList.tsx
import React, { useState, useEffect } from 'react';
import { 
  List, 
  ListItem, 
  ListItemText, 
  ListItemIcon, 
  Container, 
  Typography, 
  Box, 
  Button, 
  Grid, 
  Stepper, 
  Step, 
  StepLabel} from '@mui/material';
import axios from 'axios';
import { ThemeProvider } from '@mui/material/styles';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { footerLinks } from '../Shared/footerLinks';
import { config } from '../../../config/settings.jsx';
import { steps } from '../../../config/steps';
import { api } from '../../../config/apis.jsx';
import { getTheme } from '../../../config/theme';
import CheckIcon from '@mui/icons-material/Check';

const LaunchConsent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const cdrid = localStorage.getItem('cdrid');


  const fetchConsent = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(api.consent,
      {cdrid: cdrid},
      { headers: { 'Content-Type': 'application/json',
          apikey: config.apikey,
            tenant: config.tenant
       } }); // Replace with your actual API endpoint
      const consentLink = response.data.consentLink;
      window.location.href = consentLink // Adjust based on your API response structure
    } catch (error) {
      console.error('Error creating consent Link:', error);
    } finally {
      setIsLoading(false)
    }
  };

  return (
    <ThemeProvider theme={getTheme}>
    <Container component="main" maxWidth="xs">
 
      <Box display="flex" flexDirection="column" alignItems="center" mt={4} p={2} >
      <Grid container justifyContent="center" mb={2}>
  
      
           <Box display="flex" flexDirection="column" alignItems="center" mt={4} mb={6} style={{ width: '100%'}} >
        <Stepper activeStep={1} alternativeLabel>
        {steps.map((label) => (
          <Step key={label} >
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
        </Box>
      
        <Typography variant="h4" component="h2" align="center" mb={2} sx={{fontWeight: 'bold'}} gutterBottom>
        Welcome
      </Typography>
      
      <Box display="flex" flexDirection="column" alignItems="left" mb={2} style={{ width: '100%'}}>
      <Typography variant="body" component="h2" align="left"  sx={{fontWeight: 'bold'}}>
        Let's set up your accounts:
      </Typography>
      <Typography variant="subtitle1" component="div" align="left" mb={2} gutterBottom>
 <List>
    <ListItem>
    <ListItemIcon>
      <CheckIcon style={{ color: '#47b3b5' }} /> {/* You can change the color */}
    </ListItemIcon>
    <ListItemText primary="Up to 10 transaction accounts to track round-ups" />
      </ListItem>
    <ListItem>
    <ListItemIcon>
      <CheckIcon style={{ color: '#47b3b5' }} /> {/* You can change the color */}
    </ListItemIcon>
    <ListItemText primary="One funding account for the rounding debits every Monday, Wednesday & Friday" />
      </ListItem>
    
  </List>
   </Typography>
  <Typography variant="body" component="h2" align="left"  sx={{fontWeight: 'bold'}}>
       To continue, you will need:
      </Typography>
      <Typography variant="subtitle1" component="div" align="left" mb={2} gutterBottom>
      <List>
  <ListItem>
    <ListItemIcon>
      <CheckIcon style={{ color: '#47b3b5' }} /> {/* You can change the color */}
    </ListItemIcon>
    <ListItemText primary="Internet Banking CRN - Customer Reference Number" />
  </ListItem>
  <ListItem>
    <ListItemIcon>
      <CheckIcon style={{ color: '#47b3b5' }} />
    </ListItemIcon>
    <ListItemText primary="Internet Banking App - they'll send you a code" />
  </ListItem>
  <ListItem>
    <ListItemIcon>
      <CheckIcon style={{ color: '#47b3b5' }} />
    </ListItemIcon>
    <ListItemText primary="We don’t need and will never ask for your Bank login details" />
  </ListItem>
  
</List></Typography>
   
      </Box>
       
      </Grid>
      
   
          <Button
            onClick={fetchConsent}
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2, borderRadius: "30px", backgroundColor: '#3b469c', width: '100%'}}
            disabled={isLoading}

                  
          >
            {isLoading ? 'Loading...' : 'Continue'}
         
          </Button>


          { footerLinks }
        </Box>
    </Container> </ThemeProvider>
  );
};

export default LaunchConsent;

export {};